import React from 'react'

import Base from '../_Base'

const Error = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M7.184 15.552a3.85 3.85 0 0 1 4.865 2.432l.9 2.7a.999.999 0 0 1-.95 1.317c-.418 0-.808-.265-.948-.684l-.9-2.7a1.847 1.847 0 0 0-2.334-1.168l-2.701.9a1 1 0 1 1-.632-1.897zm13.5-4.5a1 1 0 1 1 .633 1.897l-2.701.9a1.848 1.848 0 0 0-1.167 2.335l.9 2.7a.999.999 0 0 1-.95 1.317c-.418 0-.808-.265-.948-.684l-.9-2.7a3.85 3.85 0 0 1 2.433-4.865zm-14.4-7.2a.999.999 0 0 1 1.265.632l.9 2.7a3.85 3.85 0 0 1-2.432 4.865l-2.7.9a.999.999 0 0 1-1.265-.632.999.999 0 0 1 .632-1.265l2.7-.9a1.85 1.85 0 0 0 1.168-2.335l-.9-2.7a1 1 0 0 1 .632-1.266zm5.4-1.8a1 1 0 0 1 1.265.632l.9 2.7a1.85 1.85 0 0 0 2.334 1.168l2.701-.9a1 1 0 1 1 .632 1.897l-2.7.9a3.832 3.832 0 0 1-1.213.198 3.854 3.854 0 0 1-3.652-2.63l-.9-2.7a.999.999 0 0 1 .632-1.265z"
      fillRule="evenodd"
    />
  </Base>
)

export default Error
